import { render, staticRenderFns } from "./QuizNoCorrectAnswer.vue?vue&type=template&id=7c4b0c36&scoped=true&"
import script from "./QuizNoCorrectAnswer.vue?vue&type=script&lang=js&"
export * from "./QuizNoCorrectAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QuizNoCorrectAnswer.vue?vue&type=style&index=0&id=7c4b0c36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b0c36",
  null
  
)

export default component.exports